import {_} from 'lodash';
import * as ko from "knockout";
import {ISyncField} from "../../../index";
import {FormAbstract} from "./FormAbstract";
import {ErrorTracker} from "../../../error.tracker";
import {global} from "../../../appContext";
import {PageData} from "./PageData";
import {IFormPartParameters} from "./part/index";
import {AbstractPart} from "./part/AbstractPart";

export class FormInput extends FormAbstract {
    readonly name: TFormPartName;
    private srcSyncfield: ISyncField;
    private trgSyncfield: ISyncField;
    public observable: KnockoutObservable<any | null> = ko.observable(null);
    public metaidentifier: KnockoutObservable<any | null> = ko.observable(null);
    private component: KnockoutObservable<AbstractPart | null> = ko.observable(null);
    private readonly et: ErrorTracker = global.errorAreas.get('form.view.details');

    constructor(field: IField, private pageData: PageData, protected syncfields: ISyncField[]) {
        super(field);
        const html = this.field.html ?? '';
        const nameMatch = /\[(.*?)[;\]]/gm.exec(html);
        this.name = (nameMatch?.[1] ?? '') as TFormPartName;
        const syncfieldIdentifier = /\[.*?[;\]](.*?)[;\]]/gm.exec(html)?.[1];
        if (!syncfieldIdentifier) {
            throw new Error(`Invalid form input html: ${html}`);
        }
        const syncfieldid = syncfieldIdentifier.split('.')[0];
        const metaidentifier = syncfieldIdentifier.split('.').slice(1).join('.');

        const srcSyncfield = this.syncfields.find(s => s.name.indexOf(this.name) == 1);
        const trgSyncfield = syncfields.find(s => s.syncfieldid.toString() == syncfieldid);

        this.srcSyncfield = _.cloneDeep(srcSyncfield!);
        this.trgSyncfield = _.cloneDeep(trgSyncfield!);

        this.trgSyncfield.metaidentifier = metaidentifier;

        let intervalId = setInterval(() => {
            const el = document.getElementById(this.id);
            if (el) {
                this.component(ko.dataFor(el));
                clearInterval(intervalId);
            }
        }, 10);
    }

    getHtml(): string {
        return `<!-- ko component: {name: "component/form/view/part/${this.name.toLowerCase()}", params: $component.getFormPartParameters("${this.id}") } --><!-- /ko -->`;
    }

    public getFormPartParameters(): IFormPartParameters {
        return {
            id: this.id,
            expression: this.field.html ?? '',
            value: this.observable,
            errorTracker: this.et,
            isValid: this.pageData.isValid.bind(this.pageData),
        }
    }

    getSubmitData(): ISyncField {
        const component = this.component();
        this.trgSyncfield.value = component ? String(component.getSubmitData()) : '';
        return this.trgSyncfield;
    }

    getSubmitDataButton(): ISyncField | null {
        const val = /\[.*?;.*?;(.*?)(?:;(.*?))?]/gm.exec(this.field.html ?? '')?.[1] || '';
        this.trgSyncfield.value = val;
        return this.trgSyncfield;
    }

    isValid(): boolean {
        return this.component()?.isValid() ?? false;
    }

}